import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { routes } from '@/router.js'

Vue.use(Vuex)

const initialState = {
  primaryColor: '#0F89EA',
  partnerName: 'KBC',
  showTicketsButton: true,
  showWalletButton: true,
  showMobilits: false,
  showFavoriteButton: false,
  showSupportButton: false,
  showPersonalMessage: true,
  showNMBSSupport: true,
  baseUrl: process.env.BASE_URL,
  routes
}

export default new Vuex.Store({
  state: initialState,
  getters: {
    os() {
      const os =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
          ? 'ios'
          : 'android'
      return os
    }
  },
  mutations: {
    setPrimaryColor(state, value) {
      state.primaryColor = value
    },
    setPartnerName(state, value) {
      state.partnerName = value
    },
    setShowTicketsButton(state, value) {
      state.showTicketsButton = value
    },
    setShowWalletButton(state, value) {
      state.showWalletButton = value
    },
    setShowMobilits(state, value) {
      state.showMobilits = value
    },
    setShowFavoriteButton(state, value) {
      state.showFavoriteButton = value
    },
    setShowSupportButton(state, value) {
      state.showSupportButton = value
    },
    setShowNMBSSupport(state, value) {
      state.showNMBSSupport = value
    },
    resetTheme(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },
  plugins: [
    createPersistedState({
      key: 'olympusTheme'
    })
  ]
})
